import { getQueryLangFromTLang } from '@aqx-core/common/i18n/utils';
import { companyViewController } from '@aqx-core/common/services/company/controller';
import geolocationViewController from '@aqx-core/common/services/geolocation/controller';
import { checkIsNative } from '@aqx-core/common/validators';

export const getLocalisedUrl = (url?: string | null): string | undefined => {
  if (!url) {
    return undefined;
  }

  const lang = getQueryLangFromTLang();
  try {
    const urlString = url.replace('{{language}}', lang);
    return new URL(urlString).toString();
  } catch (_err) {
    return undefined;
  }
};

export const formatMobileUrl = (url?: string | null | undefined): string | undefined => {
  const isNative = checkIsNative();
  if (!url) {
    return undefined;
  }

  // Step 1: Apply localization (replace {{language}} placeholder)
  let formattedUrl = getLocalisedUrl(url);

  // Step 2: Apply tenant-specific domain replacement if applicable
  if (companyViewController.getTenantId() === 'hantec') {
    // Mobile web handle by {{domain}} --> BE will auto format the domain according to the main domain
    // Eg. https://webtrader.hmarkets.cn -> https://hmarkets.cn
    if (isNative && formattedUrl?.includes('hmarkets.com') && geolocationViewController.getIsChina()) {
      formattedUrl = formattedUrl?.replace('hmarkets.com', 'hmarkets.cn');
    }
  }

  return formattedUrl;
};
